import React from 'react';
import { Link } from 'react-router-dom';
import arrowLeft from '../../../assets/arrow-left-long.svg';
import arrowRight from '../../../assets/arrow_right_new.png';
import dr15_2 from "../../../assets/dr15_2.png";


const StepOneContent = (
  {
    assessmentInfo,
    nextStep,
    progress,
    acceptTerms,
    step, }: any) => {
  const styles = {
    bottomBg: {
      position: "fixed" as const,
      top: "10%",
      left: 0,
      bottom: 0,
      width: "100%",
      height: "auto",
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "bottom center",
      backgroundImage: `url(${dr15_2})`,
      zIndex: -4,
    }
  }

  return (
    <>
      <div className="dasboard-content lg:w-[calc(100%-15rem)] bg-gray-sm flex flex-col">
        {progress > 0 && (
          <div className="w-full bg-gray-200 h-2 dark:bg-gray-700">
            <div
              className="bg-amber-300 h-2"
              style={{ width: `${progress}%` }}
            />
          </div>
        )}
      </div>
      <section className="dasboard-content lg:w-[calc(100%-15rem)] bg-gray-sm min-h-[calc(100vh-104px)] sm:px-3 px-1 sm:py-1 py-4 flex flex-col mb-[5rem]">
        {/* Top Section (Welcome Message) */}
        <div className="w-full flex justify-start items-start mt-4 pb-6 mb-5">
          <div className="flex flex-col gap-2 w-full">
            <span className="font-bold text-[24px] text-[#141414]" style={{ fontFamily: '"Inter", sans-serif' }}>
              Hello, User! 👋
            </span>
            <span className="font-medium text-[12px] text-[#989ca0]" style={{ fontFamily: '"Inter", sans-serif' }}>
              Welcome back, track your team progress here!
            </span>
          </div>
        </div>

        {/* Content Section */}
        <div className="">
          <h3 className="md:text-3xl sm:text-2xl text-xl font-medium" style={{ fontFamily: '"Inter", sans-serif', fontSize: "19px" }}>
            Overview
          </h3>

          <div>
            <div dangerouslySetInnerHTML={{ __html: assessmentInfo?.overview }}></div>
          </div>
        </div>

        {/* Buttons - Stuck to Bottom Right */}
        <div className="flex justify-end items-center gap-4 mt-auto">
          <Link
            to="/assessments"
            className="sm:py-4 py-2 sm:px-4 px-3 bg-dark-gray rounded-lg inline-flex items-center font-medium sm:text-base text-sm hover:bg-white-800 transition"
            style={{ fontFamily: '"Inter", sans-serif' }}
          >
            <img className="sm:mr-2 mr-1 sm:w-5 w-4" src={arrowLeft} alt="Back" />
            Back
          </Link>

          <button
            className="sm:py-4 py-2 sm:px-4 px-3 bg-blue-600 text-white rounded-lg inline-flex items-center font-medium sm:text-base text-sm hover:bg-blue-700 transition"
            style={{ zIndex: 99999, fontFamily: '"Inter", sans-serif', }}
            onClick={nextStep}
            disabled={step === 1 && !acceptTerms}
          >
            Next
            <img className="sm:ml-2 mr-1 sm:w-5 w-4" src={arrowRight} alt="Next" />
          </button>
        </div>
        <div style={styles.bottomBg}></div>

      </section>

    </>
  );
};

export default StepOneContent;
